import { lazy } from 'react'

import { LayoutType } from 'Portals/Customer/constants/layout'

import { Props } from './types'

const NotFoundPage = lazy(() => import('Shared/organisms/NotFound'))
const General = lazy(() => import('Portals/Customer/Layouts/General'))
const RegistrationDocument = lazy(() => import('Portals/Customer/Layouts/RegistrationDocument'))

const Layouts: React.FC<Props> = ({ layoutType, isEhsEnabled }) => {
	const renderComponent = () => {
		switch (layoutType) {
			case LayoutType.general:
				return <General isEhsEnabled={isEhsEnabled} />
			case LayoutType.registrationDocument:
				return <RegistrationDocument />
			default:
				return <NotFoundPage />
		}
	}
	return renderComponent()
}

export default Layouts
